import React, { Component } from 'react'
import { TableRow, MenuItem, Button, TableCell } from '@material-ui/core'

// utils
import { onChangeEditHOF } from '../../../utils/common'
import { hasAccess } from '../../../utils/api'
import {
  TableCellWithTextField,
  TableCellWithSwitch,
  TableCellWithSelect,
} from '../../../components/common/PureItems'

import EditActionComponent from '../../../components/common/EditActionComponent'

export default class ComponentGroupListItem extends Component {
  onChange = onChangeEditHOF(this.props.onChange)

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.isUpdateCompleted !== prevProps.isUpdateCompleted &&
      this.props.isUpdateCompleted === true
    ) {
      this.props.disableEdit()
    }
  }

  onSave = () => {
    this.props.onSave((response) => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  render() {
    const { data, editMode } = this.props

    return (
      <TableRow>
        <TableCellWithTextField
          valueToRender={data.name}
          editMode={editMode}
          value={data.name}
          onChange={this.onChange('name')}
          type="text"
          inputProps={{
            maxLength: 50,
          }}
        />
        {/* <TableCellWithText>{data.quantityType}</TableCellWithText> */}
        <TableCellWithSelect
          valueToRender={data.quantityType.toString()}
          value={data.quantityType}
          editMode={editMode}
          onChange={this.onChange('quantityType')}
        >
          {this.props.quantityTypeList &&
            this.props.quantityTypeList.map((i) => <MenuItem value={i}>{i}</MenuItem>)}
        </TableCellWithSelect>
        <TableCellWithSwitch
          valueToRender={data.active ? 'Active' : 'Inactive'}
          checked={data.active}
          editMode={editMode}
          onChange={this.onChange('active', true)}
        />
        {hasAccess() ? (
          <TableCell className="cell-wrap-word">
            <EditActionComponent
              onSave={this.onSave}
              onCancel={this.onCancel}
              onEdit={this.props.enableEdit}
              editMode={editMode}
            />
            {!editMode ? (
              <Button className="danger-button margin" onClick={this.props.onDelete}>
                Delete
              </Button>
            ) : null}
          </TableCell>
        ) : null}
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Settings/Manufacturing/ComponentGroupListItem.js